var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path5, _path6, _circle7, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeArts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 151,
    viewBox: "0 0 266 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 142C68.6995 142 49 122.301 49 98C49 73.6995 68.6995 54 93 54C117.301 54 137 73.6995 137 98C137 122.301 117.301 142 93 142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 96C125.49 96 104 74.5097 104 48C104 21.4903 125.49 0 152 0C178.51 0 200 21.4903 200 48C200 74.5097 178.51 96 152 96Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 151C115.072 151 90 125.928 90 95C90 64.0721 115.072 39 146 39C176.928 39 202 64.0721 202 95C202 125.928 176.928 151 146 151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94C74.6995 94 55 74.3005 55 50C55 25.6995 74.6995 6 99 6C123.301 6 143 25.6995 143 50C143 74.3005 123.301 94 99 94Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 259 49)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 53 142)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 4 75)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 48 0)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 204 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 266 135)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.791,
    y: 19.3486,
    width: 104,
    height: 104,
    rx: 16,
    transform: "rotate(3 79.791 19.3486)",
    fill: "#312FCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.103 80.4216L166.245 100.57C167.437 101.894 166.433 103.999 164.654 103.906L126.363 101.899C124.584 101.806 123.805 99.6078 125.129 98.4155L145.278 80.2736C146.099 79.5345 147.363 79.6008 148.103 80.4216Z",
    fill: "#FD6E3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.56 70.9668L146.272 99.5232C147.464 100.847 146.461 102.952 144.681 102.859L90.4125 100.015C88.6331 99.9214 87.8548 97.7233 89.1789 96.5311L117.735 70.8188C118.556 70.0797 119.821 70.146 120.56 70.9668Z",
    fill: "#FD6E3B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.084,
    cy: 53.5507,
    r: 10,
    transform: "rotate(3 140.084 53.5507)",
    fill: "#F6C630"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.5L27 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222 26.5L245 19.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 113.5L247 118",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 116.5L26 111.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeArts);
export default __webpack_public_path__ + "static/media/creative-arts.7c14a9ebe6de2af5fe84f89d353938f2.svg";
export { ForwardRef as ReactComponent };